document.addEventListener("DOMContentLoaded", function() {
     const initObfuscatedLinks = () => {
          const links = document.querySelectorAll(".obfuscated-link-js");

          links.forEach(function(link) {
               if (link.dataset.obfuscatedInitialized) return;
               
               const base64Url = link.getAttribute("data-href");
               
               if (base64Url) {
                    link.style.cursor = 'pointer'; 

                    const navigate = (event) => {
                         event.preventDefault(); 
                         event.stopPropagation();
                         
                         try {
                         const decodedUrl = atob(base64Url);
                         window.location.href = decodedUrl;
                         } catch (e) {
                         console.error("Erreur lors du décodage Base64 du lien :", e);
                         }
                    };

                    // Navigation au clic
                    link.addEventListener("click", navigate);

                    // Navigation au clavier (Entrée ou Espace)
                    link.addEventListener("keydown", function(event) {
                         if (event.key === "Enter" || event.key === " ") {
                         navigate(event);
                         }
                    });

                    link.dataset.obfuscatedInitialized = "true";
               }
          });
     };

     initObfuscatedLinks();

     // Au cas où de nouveaux liens seraient ajoutés dynamiquement (ex: filtrage)
     document.addEventListener('global:mega-menu-products-switched', initObfuscatedLinks);
});